import type { ReactNode } from "react";

import { Header, HeaderProps, Label, Radio } from "simplydo/react/ui";

type RadioHeaderProps = {
  as?: HeaderProps["as"];
  label?: string;
  label2?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: (checked?: boolean) => void;
  header?: string;
  content?: ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
  disabled?: boolean;
};

const RadioHeader = ({
  as,
  label,
  label2,
  name,
  value,
  checked,
  onChange,
  header,
  content,
  style = {},
  onClick = () => {},
  disabled,
}: RadioHeaderProps) => {
  const click = () => {
    if (onChange) {
      onChange(true);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div style={{ marginBottom: 20, display: "flex", flex: "auto", ...style }}>
      <div style={{ textAlign: "center", paddingTop: 10 }}>
        <Radio
          disabled={disabled}
          label={null}
          name={name}
          value={value}
          checked={checked}
          onClick={onClick}
          onChange={(_e, c) => onChange?.(c.checked)}
        />
      </div>
      <div style={{ paddingLeft: 15 }} onClick={disabled ? () => {} : click}>
        <Header
          as={as}
          style={{ marginBottom: 5, cursor: !disabled && "pointer" }}
        >
          {header} {label && <Label>{label}</Label>}
          {label2 && <Label>{label2}</Label>}
        </Header>
        <div>{content}</div>
      </div>

      <div style={{ clear: "both" }} />
    </div>
  );
};

export default RadioHeader;
